/**
 * Clip an HTML date input value so the year cannot exceed 4 digits.
 * Browser-native <input type="date"> allows pasting/typing arbitrary
 * year lengths (e.g. "20260" or "99999-01-01"), which is unwanted.
 *
 * Format we keep: "YYYY-MM-DD" (HTML date input native format).
 * If the year has > 4 digits, clip to the first 4.
 * Returns the (possibly clipped) value.
 */
export const clipDateYear = (val) => {
  if (typeof val !== "string" || !val) return val;
  // HTML date pattern: YYYY-MM-DD — split by "-"
  const m = val.match(/^(\d+)(-\d{2}-\d{2})?$/);
  if (!m) return val;
  const year = m[1];
  if (year.length <= 4) return val;
  return year.slice(0, 4) + (m[2] || "");
};
